import { defineStore } from 'pinia';
import { ref, nextTick } from 'vue';
import type { ContactSheetContentProps } from './ChatSheetContent.vue';

export const useMultiChatStore = defineStore('multiChat', () => {
  const selectedContact = ref<ContactSheetContentProps | null>(null);

  const openChat = async (contact: ContactSheetContentProps) => {
    if (selectedContact.value) {
      selectedContact.value = null;
      await nextTick();
    }
    selectedContact.value = contact;
  };

  const closeChat = () => {
    selectedContact.value = null;
  };

  return { selectedContact, openChat, closeChat };
});
